export default "__VITE_ASSET__BqR8y02A__"